import dayjs from 'dayjs';
import GradationalSalary from './GradationalSalary.js';
import User from './User';
import Organization from './Organization';
import SalaryAllowance from './SalaryAllowance';
import SalaryReviewAllowance from './SalaryReviewAllowance';
import AllowanceStatus from '../enums/AllowanceStatus';

export default class Allowance {
  constructor(data) {
    this.id = data?.id;
    this.organizationId = data?.organizationId;
    this.status = data?.status ? AllowanceStatus.of(data.status) : null;
    this.name = data?.name;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.organization = data?.organization ? new Organization(data?.organization) : null;

    this.salaryAllowances = data?.salaryAllowances?.map(s => new SalaryAllowance(s));
    this.salaryReviewAllowances = data?.salaryReviewAllowances?.map(s => new SalaryReviewAllowance(s));
  }
}
